import * as React from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {useEffect} from "react";
import { Add, Remove } from "@mui/icons-material";
import { FormControlLabel, FormGroup, Checkbox } from "@mui/material";
import ButtonToggleText from "../ButtonToggleText/ButtonToggleText";
import Row from "../Row/Row";

export default function TableReport({
  title,
  description,
  showCityLevel,
  showMicroLevel,
  showMacroLevel,
  data,
  state,
  filterMissing,
  city,
  tableType,
}) {
  const [geralOpen, setGeralOpen] = React.useState(
    tableType === "EstimativaReport" ? true : state
  );
  const [filters, setFilters] = React.useState({
    seeCityLevel: city.selectedCity !== "Nan",
    seeMicroLevel: city.selectedMicro !== "Nan",
    seeMacroLevel: city.selectedMacro !== "Nan",
  });

  useEffect(() => {
    if (tableType !== "EstimativaReport") {
      setGeralOpen(state);
    }
  }, [state, filterMissing, tableType]);

  const aggrupeBySubDiv = () => {
    if (!data) return;

    const normalizeKey = (key) => key?.toString().trim().toLowerCase();
    const newRowsMap = new Map();

    if (tableType === "EstimativaReport") {
      data.content.forEach((item) => {
        const attribute = {
          level: item.level ?? 0,
          date: item.id,
          customerId: item.description,
          value: item.value,
        };

        const groupKey = normalizeKey(item.reportGroup);

        if (!newRowsMap.has(groupKey)) {
          newRowsMap.set(groupKey, []);
        }
        newRowsMap.get(groupKey).push(attribute);
      });
    } else {
      data.forEach((item) => {
        const attribute = {
          level: item.level ?? 0,
          date: item.id,
          customerId: item.parameterName,
          customerCode: item.parameterCode,
          typeService: item.typeService,
          availableProvidersCity: item.availableProvidersCity,
          expectedProvidersNeedsCity: item.expectedProvidersNeedsCity,
          resultAmountCity:
            typeof item.availableProvidersCity === "string" ||
            typeof item.expectedProvidersNeedsCity === "string"
              ? "-"
              : Math.ceil(Math.ceil(item.availableProvidersCity) -
                Math.ceil(item.expectedProvidersNeedsCity)),
          availableProvidersMicro: item.availableProvidersMicro,
          expectedProvidersNeedsMicro: item.expectedProvidersNeedsMicro,
          resultAmountMicro:
            typeof item.availableProvidersMicro === "string" ||
            typeof item.expectedProvidersNeedsMicro === "string"
              ? "-"
              : Math.ceil(Math.ceil(item.availableProvidersMicro) -
                Math.ceil(item.expectedProvidersNeedsMicro)),
          availableProvidersMacro: item.availableProvidersMacro,
          expectedProvidersNeedsMacro: item.expectedProvidersNeedsMacro,
          resultAmountMacro:
            typeof item.availableProvidersMacro === "string" ||
            typeof item.expectedProvidersNeedsMacro === "string"
              ? "-"
              : Math.ceil(Math.ceil(item.availableProvidersMacro) -
                Math.ceil(item.expectedProvidersNeedsMacro)),
        };

        const groupKey = normalizeKey(item.reportGroup);
        const classKey = normalizeKey(item.reportClass);

        if (!newRowsMap.has(groupKey)) {
          newRowsMap.set(groupKey, new Map());
        }

        const reportGroupMap = newRowsMap.get(groupKey);

        if (!reportGroupMap.has(classKey)) {
          reportGroupMap.set(classKey, []);
        }

        reportGroupMap.get(classKey).push(attribute);
      });
    }

    const newRows = [];

    if (tableType === "DimensionamentoReport") {
      newRowsMap.forEach((classMap, groupName) => {
        const subCategories = [];

        classMap.forEach((attributes, className) => {
          const filteredAttributes = [];

          attributes.forEach((item) => {
            if (filterMissing === null) {
              filteredAttributes.push(item);
            } else if (
              filterMissing === true &&
              (Math.ceil(item.availableProvidersCity) <
                Math.ceil(item.expectedProvidersNeedsCity) ||
                Math.ceil(item.availableProvidersMicro) <
                Math.ceil(item.expectedProvidersNeedsMicro) ||
                Math.ceil(item.availableProvidersMacro) <
                Math.ceil(item.expectedProvidersNeedsMacro))
            ) {
              filteredAttributes.push(item);
            } else if (
              filterMissing === "equal" &&
              (Math.ceil(item.availableProvidersCity) ===
                Math.ceil(item.expectedProvidersNeedsCity) ||
                Math.ceil(item.availableProvidersMicro) ===
                Math.ceil(item.expectedProvidersNeedsMicro) ||
                Math.ceil(item.availableProvidersMacro) ===
                Math.ceil(item.expectedProvidersNeedsMacro))
            ) {
              filteredAttributes.push(item);
            } else if (
              filterMissing === false &&
              (Math.ceil(item.availableProvidersCity) >
                Math.ceil(item.expectedProvidersNeedsCity) ||
                Math.ceil(item.availableProvidersMicro) >
                Math.ceil(item.expectedProvidersNeedsMicro) ||
                Math.ceil(item.availableProvidersMacro) >
                Math.ceil(item.expectedProvidersNeedsMacro))
            ) {
              filteredAttributes.push(item);
            }
          });

          if (filteredAttributes.length > 0) {
            subCategories.push({
              className,
              attributes: filteredAttributes,
            });
          }
        });

        if (subCategories.length > 0) {
          groupName = groupName.charAt(0).toUpperCase() + groupName.slice(1);
          newRows.push({
            groupName,
            subCategories,
          });
        }
      });
    } else {
      newRowsMap.forEach((item) => {
        if (filterMissing === null) {
          newRows.push(item);
        } else if (
          filterMissing === true &&
          (Math.ceil(item.availableProvidersCity) <
            Math.ceil(item.expectedProvidersNeedsCity) ||
            Math.ceil(item.availableProvidersMicro) <
            Math.ceil(item.expectedProvidersNeedsMicro) ||
            Math.ceil(item.availableProvidersMacro) <
            Math.ceil(item.expectedProvidersNeedsMacro))
        ) {
          newRows.push(item);
        } else if (
          filterMissing === "equal" &&
          (Math.ceil(item.availableProvidersCity) ===
            Math.ceil(item.expectedProvidersNeedsCity) ||
            Math.ceil(item.availableProvidersMicro) ===
            Math.ceil(item.expectedProvidersNeedsMicro) ||
            Math.ceil(item.availableProvidersMacro) ===
            Math.ceil(item.expectedProvidersNeedsMacro))
        ) {
          newRows.push(item);
        } else if (
          filterMissing === false &&
          (Math.ceil(item.availableProvidersCity) >
            Math.ceil(item.expectedProvidersNeedsCity) ||
            Math.ceil(item.availableProvidersMicro) >
            Math.ceil(item.expectedProvidersNeedsMicro) ||
            Math.ceil(item.availableProvidersMacro) >
            Math.ceil(item.expectedProvidersNeedsMacro))
        ) {
          newRows.push(item);
        }
      });
    }

    return newRows;
  };

  const newLines = aggrupeBySubDiv();

  const hasAnyRegionSelected =
    city.selectedCity !== "Nan" ||
    city.selectedMicro !== "Nan" ||
    city.selectedMacro !== "Nan";

  return (
    <div>
      <div
        className={
          `flex flex-row justify-between items-center px-5 py-3 bg-gray-100 border-b border-gray-100` +
          (geralOpen
            ? `rounded-t-lg ${
                hasAnyRegionSelected || tableType === "EstimativaReport"
                  ? ""
                  : "mb-4"
              }`
            : ` rounded-lg mb-4`)
        }
        style={{ overflowX: "auto", flexWrap: "wrap", gap: "1rem" }}
      >
        <div className="flex items-center space-x-3">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setGeralOpen(!geralOpen)}
            className="p-1 hover:bg-gray-50 transition-colors duration-200"
          >
            {geralOpen ? (
              <Remove fontSize="small" className="text-gray-500" />
            ) : (
              <Add fontSize="small" className="text-gray-500" />
            )}
          </IconButton>
          <div className="flex flex-col space-x-2 max-w-fit">
            <div className="flex space-x-2 items-center w-fit">
              <ButtonToggleText description={description} />
              <div className="w-1.5 h-1.5 bg-emerald-400 rounded-full"></div>
              <Typography
                variant="h6"
                className="text-gray-800"
                style={{ fontSize: "0.95rem" }}
              >
                {title}
              </Typography>
            </div>
          </div>
        </div>

        {tableType !== "EstimativaReport" && (
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  color="success"
                  checked={filters.seeCityLevel && city.selectedCity !== "Nan"}
                  onChange={() =>
                    setFilters((prev) => ({
                      ...prev,
                      seeCityLevel: !prev.seeCityLevel,
                    }))
                  }
                />
              }
              label="Município"
              disabled={city.selectedCity === "Nan"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="success"
                  checked={
                    filters.seeMicroLevel && city.selectedMicro !== "Nan"
                  }
                  onChange={() =>
                    setFilters((prev) => ({
                      ...prev,
                      seeMicroLevel: !prev.seeMicroLevel,
                    }))
                  }
                />
              }
              label="Micro-região"
              disabled={city.selectedMicro === "Nan"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="success"
                  checked={
                    filters.seeMacroLevel && city.selectedMacro !== "Nan"
                  }
                  onChange={() =>
                    setFilters((prev) => ({
                      ...prev,
                      seeMacroLevel: !prev.seeMacroLevel,
                    }))
                  }
                />
              }
              label="Macro-região"
              disabled={city.selectedMacro === "Nan"}
            />
          </FormGroup>
        )}
      </div>
      <TableContainer
        component={Paper}
        square
        elevation={1}
        className=""
        sx={{
          overflowX: "hidden",
          backgroundColor: "#ffffff",
          marginBottom: tableType === "EstimativaReport" ? "16px" : "0px",
        }}
      >
        <Table
          aria-label="collapsible table"
          sx={{
            border: "none",
            tableLayout: "fixed",
          }}
        >
          <TableBody>
            {geralOpen &&
              newLines &&
              newLines.map((row, index) => {
                const key =
                  row.groupName
                    ? `row-${row.groupName}`
                    : `row-index-${index}`;
                return (
                  <Row
                    key={key}
                    stateOpen={state}
                    row={row}
                    title={
                      tableType === "EstimativaReport"
                        ? data.title
                        : row.subCategories.attributes
                    }
                    showCityLevel={
                      filters.seeCityLevel && city.selectedCity !== "Nan"
                    }
                    showMicroLevel={
                      filters.seeMicroLevel && city.selectedMicro !== "Nan"
                    }
                    showMacroLevel={
                      filters.seeMacroLevel && city.selectedMacro !== "Nan"
                    }
                    city={city}
                    tableType={tableType}
                  />
                  )

                }
              )}

          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    attributes: PropTypes.arrayOf(
      PropTypes.shape({
        level: PropTypes.number,
        customerId: PropTypes.string,
        customerCode: PropTypes.string,
        availableProvidersCity: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
        expectedProvidersNeedsCity: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
        resultAmountCity: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
        availableProvidersMicro: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
        expectedProvidersNeedsMicro: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
        resultAmountMicro: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
        expectedProvidersNeedsMacro: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
        availableProvidersMacro: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
        resultAmountMacro: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        date: PropTypes.string,
      })
    ),
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};
